export enum EAppReducers {
  USER = "USER",
  SCHEDULE = "SCHEDULE",
  BREADCRUMBS = "BREADCRUMBS",
  EXERCISE_CONSTRUCTOR = "EXERCISE_CONSTRUCTOR",
  IMAGE_UPLOAD = "IMAGE_UPLOAD",
  LESSON = "LESSON",
  EXERCISE = "EXERCISE",
}
